import classNames from 'classnames';
import _isFunction from 'lodash/isFunction';
import _isObject from 'lodash/isObject';
import _isString from 'lodash/isString';
import _kebabCase from 'lodash/kebabCase';
import _reduce from 'lodash/reduce';

function formatModifiers(base, modifiers, format) {
  return _reduce(modifiers, (mods, v, k) => Object.assign(mods, { [`${base}--${format(k)}`]: v }), {});
}

/*
  Modifiers will only be applied to the `base` arg.
  Any strings (after the `base`) will be added to the resulting className string.
    withMods('base', 'foo', 'bar', 'biz') >>> "base foo bar biz"
  All objs are assumed to be modifiers
    withMods('base', { a: true }, foo, { b: true }) >>> "base base--a base--b foo"
    withMods('base', foo, { a: true }, { b: true }) >>> "base base--a base--b foo"
  A function used to format modifiers can be passed as the last arg.
    withMods('base', { hasModifier: true }, 'foo', _.snakeCase) >>> "base base--has_modifier foo"
*/
export function classNameWithModifiers(base, ...args) {
  const lastArg = args[args.length - 1];
  const format = _isFunction(lastArg) ? lastArg : _kebabCase;
  const parsableArgs = _isFunction(lastArg) ? args.slice(0, -1) : args;
  const classes = parsableArgs.reduce((acc, arg) => {
    if (_isString(arg)) {
      return Object.assign(acc, { [arg]: true });
    }

    if (_isObject(arg)) {
      return Object.assign(acc, formatModifiers(base, arg, format));
    }

    return acc;
  }, {});

  return classNames(base, classes);
}

export function bem(blockName) {
  const block = (...args) => classNameWithModifiers(blockName, ...args);
  const element = (elementName, ...args) => classNameWithModifiers(`${blockName}__${elementName}`, ...args);
  const modifier = modifierName => `${blockName}--${modifierName}`;

  return {
    block,
    element,
    modifier,
  };
}
